
export type MaybeAccessor<T> = T | Accessor<T>;
export type MaybeAccessorValue<T extends MaybeAccessor<any>> = T extends () => any
  ? ReturnType<T>
  : T;
export const access = <T extends MaybeAccessor<any>>(v: T): MaybeAccessorValue<T> =>
    typeof v === "function" && !v.length ? v() : (v as any);